export default {
  navigation: {
    panels: ['header-site-nav', 'content-navigation'],
  },
  authenticate: {
    appClass:
      'frame__row frame__body frame__body--login frame__scroll-y no-margin',
    panels: ['content-auth'],
  },
  chart: {
    appClass: 'frame__row frame__body--chart no-margin',
    panels: ['content-chart-panel'],
  },
  'user-profile': {
    panels: ['header-site-nav', 'content-user-profile'],
  },
  'server-error': {
    appClass:
      'frame__row frame__body frame__body--login frame__scroll-y no-margin',
    panels: ['content-error'],
  },
  'application-settings': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-application-settings',
    ],
  },
  dashboards: {
    panels: ['header-site-nav', 'subnav-dashboards', 'content-dashboards'],
  },
  dashboard: {
    panels: ['header-site-nav', 'subnav-dashboards', 'content-dashboard'],
  },
  'dashboard-detail': {
    panels: ['header-site-nav', 'content-dashboard-detail'],
  },
  'create-new-dashboard': {
    panels: ['header-site-nav', 'content-new-dashboard'],
  },
  'settings-data-connectors': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-data-connectors',
    ],
  },
  //
  // Start of Setting Layouts
  //
  // General Setting Layouts
  'settings-general-client-access': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-general-client-access',
    ],
  },
  'settings-general-users': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-general-users',
    ],
  },
  'settings-general-roles': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-general-roles',
    ],
  },
  'settings-general-role-assignments': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-general-role-assignments',
    ],
  },
  'settings-general-change-log': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-general-change-log',
    ],
  },

  //
  // Start of Hierarchy Settings
  //
  'settings-general-hiearchy': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-hierarchy',
    ],
  },
  'hierarchy-details-settings': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-hierarchy-details',
    ],
  },
  'hierarchy-versions-detail-settings': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-hierarchy-versions-detail',
    ],
  },
  'hierarchy-drafts-detail-settings': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-hierarchy-drafts-detail',
    ],
  },
  'hierarchy-new-settings': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-hierarchy-new',
    ],
  },
  'hierarchy-versions': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-hierarchy-versions',
    ],
  },
  'hierarchy-versions-detail': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-hierarchy-versions-detail',
    ],
  },
  'hierarchy-new': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-hierarchy-new',
    ],
  },
  'hierarchy-setup': {
    panels: ['header-site-nav', 'content-settings-hierarchy-setup'],
  },
  //
  // Start of Master Data Settings
  //
  'settings-general-masterdata': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-masterdata',
    ],
  },
  'masterdata-details-settings': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-masterdata-details',
    ],
  },
  'content-settings-masterdata-create': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-masterdata-create',
    ],
  },
  //
  // Start of User Settings
  //
  'settings-user-details': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-user-details',
    ],
  },
  //
  // Start of Role Settings
  //
  'settings-role-edit': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-role-edit',
    ],
  },
  'settings-role-new': {
    panels: ['header-site-nav', 'subnav-settings', 'content-settings-role-new'],
  },
  //
  // Start of Assignment Rule Settings
  //
  'settings-rule-edit': {
    panels: [
      'header-site-nav',
      'subnav-settings',
      'content-settings-rule-edit',
    ],
  },
  'settings-rule-new': {
    panels: ['header-site-nav', 'content-settings-rule-new'],
  },

  //
  // End of Setting Layouts
  //

  // Start of Data Sources
  'datasources-list': {
    panels: ['header-site-nav', 'content-data-sources-list'],
  },
  datasources: {
    panels: ['header-site-nav', 'content-data-sources'],
  },
  'datasources-detail': {
    panels: ['header-site-nav', 'content-data-source-detail'],
  },
  'favorite-datasources': {
    panels: ['header-site-nav', 'content-data-source-favorites'],
  },
  // End of Data Sources
  // DBA Redir
  dba: {
    panels: ['content-dba'],
  },
  'dba-replay': {
    panels: ['content-dba-replay'],
  },
  // End of DBA Redir
};
